// Supported AI models for coach training generation.
// Keep in sync with OpenAiTrainingGenerationService::getSupportedModels() in the backend.
export const SUPPORTED_AI_MODELS = ['gpt-4.1-mini', 'gpt-5-mini'];

// Keep in sync with OpenAiTrainingGenerationService::getDefaultSeedModel() in the backend.
export const DEFAULT_AI_MODEL = 'gpt-5-mini';

export const AI_MODEL_LABELS = {
    'gpt-4.1-mini': 'GPT-4.1 mini',
    'gpt-5-mini': 'GPT-5 mini',
};

export const getAiModelLabel = (model) => AI_MODEL_LABELS[model] || model;

export const resolveAiModelOptions = (currentModel) => {
    const trimmedModel = (currentModel || '').trim();

    if (trimmedModel && !SUPPORTED_AI_MODELS.includes(trimmedModel)) {
        return [trimmedModel, ...SUPPORTED_AI_MODELS];
    }

    return SUPPORTED_AI_MODELS;
};
